"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactInlinesvg = _interopRequireDefault(require("react-inlinesvg"));

var _Elements = _interopRequireDefault(require("./Elements"));

var _TooltipPointer = _interopRequireDefault(require("../../assets/icons/Tooltip-pointer.svg"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/* eslint-disable no-param-reassign */

/* eslint-disable react/forbid-prop-types */
var Popover = function Popover(_ref) {
  var id = _ref.id,
      triggerRef = _ref.triggerRef,
      triggerShow = _ref.triggerShow,
      attr = _ref.attr,
      onClickout = _ref.onClickout,
      show = _ref.show,
      children = _ref.children,
      render = _ref.render,
      arrow = _ref.arrow,
      alignment = _ref.alignment,
      fullWidth = _ref.fullWidth,
      width = _ref.width,
      forceBelow = _ref.forceBelow,
      popoverNestedRole = _ref.popoverNestedRole,
      position = _ref.position,
      popoverMaxHeight = _ref.popoverMaxHeight,
      popoverParentHeight = _ref.popoverParentHeight,
      noFocusOnOpen = _ref.noFocusOnOpen,
      noEnterToOpen = _ref.noEnterToOpen,
      arrowOffsetFromEdge = _ref.arrowOffsetFromEdge,
      zIndex = _ref.zIndex;
  var clickoutRef = (0, _react.useRef)(null);
  var accessibilityRef = (0, _react.useRef)(null);
  var wrapperRef = (0, _react.useRef)(null);
  var arrowRef = (0, _react.useRef)(null); // Accessibility for enter to open the popover

  (0, _react.useEffect)(function () {
    if (!noEnterToOpen && triggerRef.current) {
      triggerRef.current.onkeydown = function (e) {
        if (e.key === 'Enter') {
          triggerShow(e);
        }
      };
    }

    return function () {
      if (triggerRef.current) {
        triggerRef.current.onkeydown = function () {};
      }
    };
  }, [show]);
  var isBelow = true;
  var wrapperHeight = '0';

  if (wrapperRef.current && show && !forceBelow) {
    var wrapperRect = wrapperRef.current.getBoundingClientRect();

    if (window.innerHeight < wrapperRect.bottom) {
      isBelow = false;
      wrapperHeight = wrapperRect.height;
    }
  }

  var arrowLeft = null;

  if (wrapperRef.current && triggerRef.current && show) {
    var triggerRect = triggerRef.current.getBoundingClientRect();

    var _wrapperRect = wrapperRef.current.getBoundingClientRect();

    if (_wrapperRect.width > triggerRect.width) {
      arrowLeft = triggerRect.width / 2;
    } else {
      // Makes up for left, center or right justified tooltip
      // regardless of relative size of calling element or popover
      var xOffset = Math.abs(triggerRect.x - _wrapperRect.x);
      arrowLeft = _wrapperRect.width / 2 + xOffset;
    }
  }

  var clickoutHandler = function clickoutHandler(ref) {
    var handleClickOutside = function handleClickOutside(event) {
      if (show && ref.current && !ref.current.contains(event.target)) {
        // triggerRef.current.focus();
        onClickout();
      }
    };

    var handleEsc = function handleEsc(event) {
      if (event.key === 'Escape' && show) {
        // triggerRef.current.focus();
        onClickout();
      }
    };

    (0, _react.useEffect)(function () {
      document.addEventListener('mousedown', handleClickOutside);
      document.addEventListener('keydown', handleEsc);
      return function () {
        document.removeEventListener('mousedown', handleClickOutside);
        document.removeEventListener('keydown', handleEsc);
      };
    });
  };

  clickoutHandler(clickoutRef);
  (0, _react.useEffect)(function () {
    if (!noFocusOnOpen) accessibilityRef.current.focus();
  }, []);
  return /*#__PURE__*/_react["default"].createElement(_Elements["default"], {
    id: id,
    key: id,
    show: show,
    arrow: arrow,
    arrowLeft: arrowLeft,
    isBelow: isBelow,
    wrapperHeight: wrapperHeight,
    fullWidth: fullWidth,
    width: width,
    ref: clickoutRef,
    alignment: alignment // Position describes the location of the popover relative to the element that activates it
    ,
    position: position,
    popoverMaxHeight: popoverMaxHeight,
    popoverParentHeight: popoverParentHeight,
    arrowOffsetFromEdge: arrowOffsetFromEdge,
    zIndex: zIndex
  }, children, /*#__PURE__*/_react["default"].createElement(_reactInlinesvg["default"], {
    cacheRequests: true,
    className: "arrow",
    ref: arrowRef,
    src: _TooltipPointer["default"],
    uniquifyIDs: true
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: "popover-wrapper",
    ref: wrapperRef,
    role: "dialog"
  }, /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({
    className: "popover",
    role: popoverNestedRole,
    ref: accessibilityRef
  }, attr), render)));
};

Popover.propTypes = {
  id: _propTypes["default"].string.isRequired,
  triggerRef: _propTypes["default"].shape({
    current: _propTypes["default"].any
  }).isRequired,
  triggerShow: _propTypes["default"].func,
  attr: _propTypes["default"].object,
  onClickout: _propTypes["default"].func,
  show: _propTypes["default"].bool,
  children: _propTypes["default"].node.isRequired,
  render: _propTypes["default"].node.isRequired,
  arrow: _propTypes["default"].bool,
  fullWidth: _propTypes["default"].bool,
  width: _propTypes["default"].number,
  forceBelow: _propTypes["default"].bool,
  popoverNestedRole: _propTypes["default"].string.isRequired,
  alignment: _propTypes["default"].string,
  position: _propTypes["default"].oneOf(['top', 'bottom', 'left', 'bottom-left', 'right']),
  popoverMaxHeight: _propTypes["default"].number,
  popoverParentHeight: _propTypes["default"].number,
  noFocusOnOpen: _propTypes["default"].bool,
  noEnterToOpen: _propTypes["default"].bool,
  arrowOffsetFromEdge: _propTypes["default"].number,
  zIndex: _propTypes["default"].number
};
Popover.defaultProps = {
  arrow: false,
  show: false,
  attr: {},
  alignment: 'start',
  fullWidth: false,
  width: null,
  forceBelow: true,
  triggerShow: function triggerShow() {},
  onClickout: function onClickout() {},
  position: 'bottom',
  popoverMaxHeight: 260,
  popoverParentHeight: null,
  noFocusOnOpen: false,
  noEnterToOpen: false,
  arrowOffsetFromEdge: 0,
  zIndex: 1
};
var _default = Popover;
exports["default"] = _default;